const externalApi = (() => {
  async function getCoverImage() {
    const response = await fetch('https://source.unsplash.com/960x300/?beach');
    if (!response) throw new Error('Failed to load cover image');
    const blob = await response.blob();
    const objurl = URL.createObjectURL(blob);
    return objurl;
  }

  async function getRandomJoke() {
    const response = await fetch(
      'https://official-joke-api.appspot.com/random_joke'
    );
    const randomJoke = await response.json();
    if (!randomJoke) throw new Error('Failed to load random joke');
    return randomJoke;
  }

  async function getGeeksJoke() {
    const response = await fetch(
      'https://official-joke-api.appspot.com/jokes/programming/random'
    );
    const geeksJoke = await response.json();
    if (!geeksJoke) throw new Error('Failed to load random joke');
    return geeksJoke;
  }

  return {
    getCoverImage,
    getRandomJoke,
    getGeeksJoke,
  };
})();

export default externalApi;
